import { render } from "./stock.vue?vue&type=template&id=00d62970&scoped=true"
import script from "./stock.vue?vue&type=script&lang=js"
export * from "./stock.vue?vue&type=script&lang=js"

import "./stock.vue?vue&type=style&index=0&id=00d62970&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d62970"]])

export default __exports__